module.exports = __webpack_public_path__ + "static/media/adriatic.c7d31dbc.png";